import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ExternalLink } from 'lucide-react';
import { SUPPORT_EMAIL } from '../../content/siteContent';
import { PageBackLink, PageHero, PagePanel, PageShell } from '../MarketingPageShell';

const GITHUB_URL = 'https://github.com/123colby';
const AVATAR_URL = 'https://github.com/123colby.png';

const AboutPage = () => {
  return (
    <PageShell>
      <div className="space-y-10 py-4">
        <PageBackLink />
        <div className="mx-auto desktop-page-width-lg space-y-8">
          <PageHero
            title="About Toolip"
            description="Toolip is a personal project I built myself, and I still handle the product, website, updates, and support."
          />

          <PagePanel className="overflow-hidden border-blue-400/20 bg-gradient-to-br from-blue-500/10 via-slate-900/70 to-cyan-500/5">
            <div className="grid gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:items-start">
              <div>
                <div className="inline-flex rounded-full border border-emerald-400/30 bg-emerald-400/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.3em] text-emerald-200">
                  Toolip Developer
                </div>
                <h2 className="mt-5 text-3xl font-semibold text-white">Hi, I&apos;m Colby</h2>
                <p className="mt-4 text-gray-300 leading-8">
                  I built Toolip because I wanted a desktop toolbelt that felt useful, simple, and easy to keep coming back to.
                  Everything around it is still handled by me, from the app itself to the website and release updates.
                </p>
                <p className="mt-4 text-gray-300 leading-8">
                  If you use Toolip, you&apos;re supporting one independent developer directly. I like that it stays personal,
                  and I want the product to feel cohesive and focused.
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <a
                    href={GITHUB_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 rounded-xl bg-white px-5 py-3 text-sm font-medium text-slate-900 transition-colors hover:bg-slate-200"
                  >
                    <ExternalLink className="h-4 w-4" />
                    GitHub
                  </a>
                  <Link
                    to="/contact"
                    className="inline-flex items-center rounded-xl border border-white/10 bg-white/5 px-5 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10"
                  >
                    Contact me
                  </Link>
                </div>
              </div>

              <div className="flex justify-center lg:justify-end">
                <div className="w-full max-w-sm rounded-[2rem] border border-white/10 bg-black/20 p-6 text-center shadow-2xl shadow-black/20">
                  <img
                    src={AVATAR_URL}
                    alt="Colby GitHub avatar"
                    className="mx-auto h-36 w-36 rounded-full border border-white/10 object-cover shadow-lg shadow-blue-950/40"
                  />
                  <div className="mt-5 text-2xl font-semibold text-white">Colby</div>
                  <p className="mt-2 text-sm uppercase tracking-[0.25em] text-slate-400">Developer behind Toolip</p>
                  <p className="mt-4 text-sm leading-7 text-slate-300">
                    Building Toolip independently and improving it over time.
                  </p>
                  <a
                    href={GITHUB_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-5 inline-flex items-center gap-2 text-sm text-blue-200 transition-colors hover:text-white"
                  >
                    github.com/123colby
                    <ExternalLink className="h-4 w-4" />
                  </a>
                </div>
              </div>
            </div>
          </PagePanel>

          <PagePanel>
            <h2 className="mb-4 text-2xl font-semibold text-white">Support the developer behind it</h2>
            <p className="text-gray-300 leading-relaxed">
              Every download, subscription, and recommendation supports the person building Toolip directly.
              If you have a product question, bug report, or business inquiry, the contact address is{' '}
              <span className="text-white">{SUPPORT_EMAIL}</span>.
            </p>
          </PagePanel>
        </div>
      </div>
    </PageShell>
  );
};

export default AboutPage;
